import { Modal } from "react-bootstrap";
import { useState, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { IResponseModalProps, IResponseState } from "./module/constants";

import messages from "../ResponseModal/module/messages";

// Import styles
import classes from "./ResponseModal.module.scss";
import Loader from "../../Loader/Loader";
import {
  FaCheckCircle,
  FaExclamationTriangle,
  FaRegTimesCircle,
} from "react-icons/fa";

const ResponseModal = (props: IResponseModalProps) => {
  const {
    onClose,
    show,
    state,
    showSuccessForwardMessage,
    failureMessage,
    infoMessage,
    customMessage,
    successExtraContent,
    hideDefaultErrorMessage,
  } = props;
  const [extraTxt, setExtraTxt] = useState<string>("");

  useEffect(() => {
    if (successExtraContent) setExtraTxt(successExtraContent);
  }, [successExtraContent]);

  return (
    <>
      <Modal show={show} centered contentClassName={classes.content}>
        <Modal.Header className={classes.header}>
          <Modal.Title style={{ fontSize: "1rem" }}>
            {state === IResponseState.ERROR && (
              <FormattedMessage {...messages.errorTitle} />
            )}
            {state === IResponseState.PENDING && (
              <FormattedMessage {...messages.pendingTitle} />
            )}
            {(state === IResponseState.WARNING ||
              state === IResponseState.SUCCESS) && (
              <FormattedMessage {...messages.successTitle} />
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ fontSize: "0.75rem" }}>
          <div className={classes["body-content"]}>
            <div className={classes["gif-container"]}>
              {state === IResponseState.ERROR && (
                <div className={classes["warn"]}>
                  <FaRegTimesCircle />
                </div>
              )}
              {state === IResponseState.PENDING && <Loader />}
              {state === IResponseState.WARNING && (
                <div className={classes["succwarn"]}>
                  <FaExclamationTriangle />
                </div>
              )}
              {state === IResponseState.SUCCESS && (
                <div className={classes["success"]}>
                  <FaCheckCircle />
                </div>
              )}
            </div>
            <div className={classes["text-content"]}>
              {state === IResponseState.ERROR && (
                <>
                  {!hideDefaultErrorMessage && (
                    <FormattedMessage {...messages.errorBodyContent} />
                  )}
                  {failureMessage && <div>{failureMessage}</div>}
                </>
              )}
              {state === IResponseState.PENDING && (
                <FormattedMessage {...messages.pendingBodyContent} />
              )}
              {state === IResponseState.WARNING && (
                <>
                  <FormattedMessage {...messages.warningBodyContent} />
                  {infoMessage && (
                    <div
                      style={{
                        overflowY: "auto",
                        padding: "0rem",
                        maxHeight: "3.125rem",
                      }}
                    >
                      {infoMessage}
                    </div>
                  )}
                </>
              )}
              {state === IResponseState.SUCCESS && (
                <>
                  {!showSuccessForwardMessage && !customMessage && (
                    <FormattedMessage {...messages.successBodyContent} />
                  )}
                  {showSuccessForwardMessage && (
                    <FormattedMessage {...messages.successForwardBodyContent} />
                  )}
                  {customMessage && (
                    <div
                      style={{
                        overflowY: "auto",
                        padding: "0rem",
                        maxHeight: "3.125rem",
                      }}
                    >
                      {customMessage}
                    </div>
                  )}
                  {infoMessage && (
                    <div
                      style={{
                        overflowY: "auto",
                        padding: "0rem",
                        maxHeight: "3.125rem",
                      }}
                    >
                      {infoMessage}
                    </div>
                  )}
                </>
              )}
            </div>
            {state === IResponseState.SUCCESS && successExtraContent && (
              <div style={{ textAlign: "center" }}>{extraTxt}</div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer className={classes.footer}>
          <button
            className={`${classes.btn} ${classes["btn-cancel"]}`}
            onClick={onClose}
          >
            <FormattedMessage {...messages.close} />
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ResponseModal;
